import { Component, Inject, Optional } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogContent } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AuthManager } from 'src/app/core/auth/auth.manager';
import { PrepLocationForComponent } from 'src/app/common/models/prep-location';
import { IPrepLocationHoursOverride } from 'src/app/common/models/prep-location-hours-override';
import { PrepLocationsService } from 'src/app/services/prep-locations.service';
import { OverrideDeleteConfirmComponent } from './override-delete-confirm/override-delete-confirm.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgClass, DatePipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { OverrideTimeViewPipe } from '@pipes/time-date-pipe';

@Component({
  selector: 'app-hours-exception-view',
  templateUrl: './hours-exception-view.component.html',
  styleUrls: ['./hours-exception-view.component.scss'],
  standalone: true,
  imports: [CdkScrollable, MatDialogContent, NgClass, MatButton, DatePipe, OverrideTimeViewPipe],
})
export class HoursExceptionViewComponent {
  public authManager: AuthManager;
  public hoursOverrides: IPrepLocationHoursOverride[];
  public selectedIndex = -1;

  constructor(
    private prepService: PrepLocationsService,
    public dialogRef: MatDialogRef<HoursExceptionViewComponent>,
    private dialog: MatDialog,
    @Optional() @Inject(MAT_DIALOG_DATA) public prepLocation: PrepLocationForComponent,
    private auth: AuthManager,
    private toastr: ToastrService,
  ) {
    this.authManager = this.auth;
    this.hoursOverrides = prepLocation.hoursOverrides;
  }

  public setSelectedRow(rowIndex: number): void {
    this.selectedIndex = rowIndex;
  }

  public deleteOverride(ho: IPrepLocationHoursOverride): void {
    this.prepService.deleteHoursOverride(ho).subscribe({
      next: (res) => {
        if (res === null) {
          this.toastr.success('Hours Override Removed');
          this.hoursOverrides.splice(this.selectedIndex, 1);
        } else {
          this.toastr.error('Error when removing Hours Override');
        }
      },
      error: (e) => {
        this.toastr.error('Error when removing Hours Override');
      },
    });
  }

  public onNoClick(): void {
    this.dialogRef.close();
  }

  public deleteOverrideConfirm(hoursOverride: IPrepLocationHoursOverride): void {
    const confirmDialogRef = this.dialog.open(OverrideDeleteConfirmComponent, {
      width: '340px',
      height: '210px',
      data: hoursOverride,
    });

    confirmDialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.deleteOverride(hoursOverride);
      }
    });
  }
}
